import React, { ComponentProps } from 'react';

import { Modal } from 'semantic-ui-react';
import { ModalContents } from './ModalContents';

export type Props = {
  isOpen: boolean;
} & ComponentProps<typeof ModalContents>;

export const ContactModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  setFieldValue,
  mode = 'new',
  targetContact,
}) => {
  return (
    <Modal
      closeOnDimmerClick={false}
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <ModalContents
        setIsOpen={setIsOpen}
        setFieldValue={setFieldValue}
        mode={mode}
        targetContact={targetContact}
      />
    </Modal>
  );
};
